import axiosInstance from '../services/axiosInstance';
import { envUrls } from './env';

// Uncomment this to run service locally
// envUrls.documentService = 'http://localhost:4089/document/';

export default class DocumentService {
  async fetchDocuments(payload) {
    return await axiosInstance
      .post(`${envUrls.documentService}fetch/documents`, payload, {
        headers: {
          appName: 'bluescout',
        },
      })
      .then((response) => response.data)
      .catch((err) => console.log(err));
  }

  async fetchFilters(payload) {
    return await axiosInstance
      .post(`${envUrls.documentService}fetch/filters`, payload, {
        headers: {
          appName: 'bluescout',
        },
      })
      .then((response) => response.data)
      .catch((err) => console.log(err));
  }
}
